// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"06da3390","578":"5549b4c1","914":"5549b4c1","986":"5549b4c1"}[chunkId] + ".chunk.css";
};